import React from 'react';

import {
  CentreVHUDto,
  CentreVHUViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';

import { CentreVHUFormValues } from '../types';
import { buildFormValues, buildRequestDto } from '../utils';

import ModalEditionCentreVHU from './ModalEditionCentreVHU';

interface ModalUpdateProps {
  close: () => void;
  visible: boolean;
  refreshDashboard: () => void;
  centreVHU: CentreVHUDto;
}

export default function ModalUpdate({
  close,
  visible,
  refreshDashboard,
  centreVHU,
}: ModalUpdateProps): React.ReactElement {
  const initials: CentreVHUFormValues = buildFormValues(centreVHU);
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: CentreVHUFormValues) =>
      AdminFonctionnelControllerApi.updateCentreVHUUsingPUT(
        centreVHU.idCorrelation,
        buildRequestDto(values),
      ),
  );
  const { validate } = useValidateReferentielForm(
    (field: CentreVHUViolationDtoFormFieldEnum, values: CentreVHUFormValues) =>
      AdminFonctionnelControllerApi.validateUpdateCentreVHUFieldUsingPOST(
        field,
        centreVHU.idCorrelation,
        buildRequestDto(values),
      ),
    response => response.centreVHUViolationsDto ?? [],
  );

  return (
    <ModalEditionCentreVHU
      close={close}
      visible={visible}
      title="Mettre à jour le centre VHU"
      initials={initials}
      isSubmitting={inProgress}
      submit={submit}
      validate={validate}
    />
  );
}
